const name = 'BaseSequence';
const properties = {};
function animate(kit, params) {
    return kit.engine.timeline(params, []);
}
export { name, properties, animate };
//# sourceMappingURL=baseSequence.js.map